import { SVGProps } from "react";

const ArrowStright = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={10}
    viewBox="0 0 14 10"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 5H13"
      stroke="#808080"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 1L13 5L9 9"
      stroke="#808080"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ArrowStright;
